module.exports = __webpack_public_path__ + "static/TFP-logo-header-black.8a56e28c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TFP-logo-header-black.png
// module id = 405
// module chunks = 114276838955818